module.exports = __webpack_public_path__ + "img/napas.7eba271a.png";